/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerFieldSetGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Field Set Groups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 12:47 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    FIELDSETGROUP_LIST_CONTAINER_LOADED,
    FIELDSETGROUP_LIST_CONTAINER_UNLOADED,
    FIELDSETGROUP_LIST_TABLE_LOADED,
    FIELDSETGROUP_LIST_TABLE_UNLOADED,

    FIELDSETGROUP_SELECT_ROW,
    FIELDSETGROUP_ADD,
    FIELDSETGROUP_EDIT,
    FIELDSETGROUP_DELETE,
    FIELDSETGROUP_OPEN_WARNING,
    FIELDSETGROUP_CLOSE_WARNING,
    FIELDSETGROUP_DELETE_DISABLE,

    FIELDSETGROUP_EDIT_CONTAINER_LOADED,
    FIELDSETGROUP_EDIT_CONTAINER_UNLOADED,
    FIELDSETGROUP_EDIT_FORM_LOADED,
    FIELDSETGROUP_EDIT_FORM_UNLOADED,
    FIELDSETGROUP_EDIT_DATA_LOAD,
    FIELDSETGROUP_EDIT_CONTAINER_SUBMIT,
    FIELDSETGROUP_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeFieldSetGroups';

const defaultState = {
    refreshList: false,
    danger: false,
    fieldsetgroupid: 0,
    parentid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case FIELDSETGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                fieldsetgroups: action.payload[0] ? action.payload[0].records : null,
                itempath: action.payload[1] ? action.payload[1].records : []
            }
        case FIELDSETGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case FIELDSETGROUP_SELECT_ROW:
            return {
                ...state,
                fieldsetgroupid: action.id
            }
        case FIELDSETGROUP_ADD:
            return {
                ...state
            }
        case FIELDSETGROUP_EDIT:
            return {
                ...state,
                fieldsetgroupid: action.id
            }
        case FIELDSETGROUP_DELETE:
            return {
                ...state,
                fieldsetgroupid: null
            }
        case FIELDSETGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case FIELDSETGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case FIELDSETGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case FIELDSETGROUP_EDIT_CONTAINER_LOADED:
        case FIELDSETGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                fieldsetgroupid: action.payload[0] ? action.payload[0].fieldsetgroupid : 0,
                parentid: action.payload[0] ? action.payload[0].parentid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case FIELDSETGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case FIELDSETGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case FIELDSETGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case FIELDSETGROUP_LIST_CONTAINER_UNLOADED:
        case FIELDSETGROUP_LIST_TABLE_UNLOADED:
        case FIELDSETGROUP_EDIT_CONTAINER_UNLOADED:
        case FIELDSETGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerFieldSetGroups.js